"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitcoinHashUtils = void 0;
const ethers_1 = require("ethers");
const utils_1 = require("../utils");
/**
 * Computes the HASH160 (i.e. RIPEMD160(SHA256(text))) for the given text.
 * @param text Text the HASH160 is computed for.
 * @returns 20-byte-long hash.
 */
function computeHash160(text) {
    const sha256Hash = ethers_1.utils.sha256(text.toPrefixedString());
    const hash160 = ethers_1.utils.ripemd160(sha256Hash);
    return utils_1.Hex.from(hash160);
}
/**
 * Computes the double SHA256 for the given text.
 * @param text Text the double SHA256 is computed for.
 * @returns 32-byte-long hash.
 * @dev Do not confuse it with computeSha256 which computes single SHA256.
 */
function computeHash256(text) {
    const firstHash = ethers_1.utils.sha256(text.toPrefixedString());
    const secondHash = ethers_1.utils.sha256(firstHash);
    return utils_1.Hex.from(secondHash);
}
/**
 * Converts a hash in hex string in little endian to a BigNumber.
 * @param hash Hash in hex-string format.
 * @returns BigNumber representation of the hash.
 */
function hashLEToBigNumber(hash) {
    return ethers_1.BigNumber.from(hash.reverse().toPrefixedString());
}
/**
 * Computes the single SHA256 for the given text.
 * @param text Text the single SHA256 is computed for.
 * @returns 32-byte-long hash.
 * @dev Do not confuse it with computeHash256 which computes double SHA256.
 */
function computeSha256(text) {
    const hash = ethers_1.utils.sha256(text.toPrefixedString());
    return utils_1.Hex.from(hash);
}
/**
 * Utility functions allowing to deal with Bitcoin hashes.
 */
exports.BitcoinHashUtils = {
    computeHash160,
    computeHash256,
    hashLEToBigNumber,
    computeSha256,
};
//# sourceMappingURL=hash.js.map